<template>
  <div class="wrapper-x-40 engraving-text">
    <AdminStickyHeader>
      <template #title>
        {{$t('admin.views.engraving.text_params')}}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap items-center gap-3">
          <button
            @click="saveData"
            type="button"
            class="btn btn-small btn-green"
          >
            {{$t('main.button_save')}}
          </button>
        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <div class="flex items-start">
        <div class="w-1/2">
          <div class="form-group">
            <label
              for="price"
              class="text-sm"
            >{{$t('admin.views.engraving.fix_price_for_1_symbol')}}*:</label>
            <div class="w-28">
              <input
                id="price"
                type="number"
                v-model="form.engravingPriceSymbol"
                prlaceholder="0.00"
              />
            </div>
            <ValidationErrors :errors="errorsFor('price')" />
          </div>
          <div class="form-group cost-value">
            <label
              for="cost"
              class="text-sm"
            >{{$t('main.label_text_cost')}}:</label>
            <div class="w-28">
              <input
                id="cost"
                type="number"
                v-model="form.engravingCostSymbol"
                placeholder="0.00"
              />
            </div>
            <ValidationErrors :errors="errorsFor('cost')" />
          </div>
          <div class="form-group">
            <div class="font-bold mb-2">{{ $t('main.sizes') }} *:</div>

            <div class="text-sizes-list">
              <div
                class="flex items-end mb-4"
                v-for="(size, index) in sizes"
                :key="`text-size-${index}`"
              >
                <div class="size-number w-8 text-xl">{{ index + 1 }}.</div>

                <div class="size-data flex gap-6 items-end">

                  <div>
                    <label
                      class="text-xs"
                      :for="`height-${index}`"
                    >{{$t('main.height_sm')}}:</label>
                    <input
                      class="w-12 text-center"
                      v-model="sizes[index].height"
                      type="text"
                      :id="`height-${index}`"
                      placeholder="0"
                    />
                  </div>

                  <div>
                    <label
                      class="text-xs"
                      :for="`cost_coefficient-${index}`"
                    >{{$t('main.coef_price')}}:</label>
                    <input
                      type="text"
                      class="w-12 text-center"
                      :id="`cost_coefficient-${index}`"
                      placeholder="1"
                      v-model="sizes[index].cost_coefficient"
                    />
                  </div>
                  <div
                    class="size-remove ml-6"
                    v-if="index"
                  >
                    <button
                      @click="removeSize(size.id)"
                      class="border-sky-blue px-2 rounded"
                      style="height: 36px"
                    >
                      <i class="fas fa-times fa-lg text-red-500"></i>
                    </button>
                  </div>

                </div>

              </div>
            </div>

            <div class="flex mt-6">
              <div class="w-8"></div>
              <div>
                <button
                  class="btn btn-default btn-small"
                  @click="addSize"
                >
                  {{ $t('main.button_add_block_sizes') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/2 ml-30">
          <div class="form-group">
            <div class="font-bold mb-2">{{ $t('main.fonts') }} *:</div>
            <div>
              <div class="flex items-center mb-2">
                <input
                  type="radio"
                  id="engravingAllFonts"
                  :checked="form.engravingAllFonts == 1"
                  v-model="form.engravingAllFonts"
                  :value="1"
                />
                <label
                  for="engravingAllFonts"
                  class="ml-2 leading-5"
                >{{$t('admin.views.engraving.all_fonts_from_list')}}</label>
              </div>

              <div class="flex items-center mb-2">
                <input
                  type="radio"
                  id="engravingAllFonts-false"
                  :checked="form.engravingAllFonts == 0"
                  v-model="form.engravingAllFonts"
                  :value="0"
                />
                <label
                  for="engravingAllFonts-false"
                  class="ml-2 leading-5"
                >{{$t('admin.views.engraving.choice_fonts')}}</label>
              </div>
              <div
                v-if="fonts.length && !form.engravingAllFonts"
                class="fonst-list ml-5"
              >
                <div class="h-96 overflow-y-auto pr-2">
                  <div
                    class="font-item flex gap-4 justify-between mb-3 items-center"
                    v-for="font in fonts"
                    :key="`font-${font.id}`"
                  >

                    <div class="font-name flex items-center gap-2">
                      <button
                        class="flex items-center focus:outline-none"
                        @click="toggleFont(font.id)"
                      >
                        <span class="check"><i
                            v-if="checkedFont(font.id)"
                            class="fas fa-check text-red-500"
                          ></i></span>
                      </button>
                      <span
                        @click="toggleFont(font.id)"
                        :style="{fontFamily: font.name}"
                      >
                        {{ font.name }}
                      </span>
                    </div>
                    <div
                      class="font-action flex gap-2"
                      v-if="!font.default"
                    >
                      <button
                        class="button-edit"
                        @click="editingFont=font"
                      ><img
                          src="/images/icons/engraving-text/redaktirovat.svg"
                          alt=""
                        ></button>
                      <button
                        class="button-delete"
                        @click="deletingFont=font"
                      ><img
                          src="/images/icons/engraving-text/udalit.svg"
                          alt=""
                        ></button>
                    </div>

                  </div>
                </div>

                <div class="mt-4">
                  <button
                    class="btn btn-default btn-small"
                    @click="uploadingFont=true"
                  >
                    {{ $t('main.button_add_font') }}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="uploadingFont||editingFont"
      @close-modal="closeModal"
    >
      <div
        v-if="uploadingFont"
        class="font-bold mb-4"
      >{{$t('main.uploadingFont')}}</div>
      <div
        v-if="editingFont"
        class="font-bold mb-4"
      >{{$t('main.editingFont')}}</div>
      <form-engraving-text
        :upload="uploadingFont"
        :edit="editingFont"
        @success="closeModal"
      />
    </Modal>
    <Modal
      v-if="deletingFont"
      @close-modal="deletingFont=null"
    >
      <div class="font-bold mb-4">Вы уверены что хотите удалить шрифт "{{deletingFont.name}}"?</div>
      <div>

        <button
          class="btn btn-small btn-red"
          @click="deleteFont"
        >Да</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";
import { v4 as uuidv4 } from "uuid";
import FormEngravingText from "../../../components/Admin/EngravingText/FormEngravingText.vue";
export default {
  mixins: [validationErrors],
  components: { AdminStickyHeader, FormEngravingText },
  name: "EngravingText",
  props: ["settings"],
  data() {
    return {
      uploadingFont: false,
      editingFont: null,
      deletingFont: null,
      loadingSaveData: false,
      sizes: [],
      form: {
        engravingPriceSymbol: 0,
        engravingCostSymbol: 0,
        engravingAllFonts: 1,
        engravingSelectedFonts: [],
      },
    };
  },
  created() {
    this.$store.dispatch("fonts/fetch");
  },

  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });

    if (this.sizes.length == 0) {
      this.addSize();
    }

    for (const key in this.settings) {
      if (key == "engravingPriceSymbol") {
        this.form.engravingPriceSymbol = this.settings[key];
      }
      if (key == "engravingCostSymbol") {
        this.form.engravingCostSymbol = this.settings[key];
      }
      if (key == "engravingAllFonts") {
        this.form.engravingAllFonts = parseInt(this.settings[key]);
      }
      if (key == "fontSizes") {
        this.sizes = JSON.parse(this.settings[key]);
      }
      if (key == "engravingSelectedFonts") {
        this.form.engravingSelectedFonts = JSON.parse(this.settings[key]);
      }
    }
  },
  computed: {
    fonts() {
      return this.$store.state.fonts.fonts;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    closeModal() {
      this.uploadingFont = false;
      this.editingFont = null;
    },
    addSize() {
      this.sizes.push({
        id: uuidv4(),
        height: null,
        coef: null,
      });
    },
    removeSize(id) {
      this.sizes = this.sizes.filter((size) => size.id != id);
    },
    checkedFont(fontId) {
      return this.form.engravingSelectedFonts.find((fId) => fId == fontId);
    },
    toggleFont(fontId) {
      if (this.checkedFont(fontId)) {
        this.form.engravingSelectedFonts =
          this.form.engravingSelectedFonts.filter((fId) => fId != fontId);
      } else {
        this.form.engravingSelectedFonts.push(fontId);
      }
    },
    async deleteFont(font) {
      try {
        await this.$store.dispatch("fonts/delete", this.deletingFont.id);
        const notification = {
          type: "success",
          message: "Шрифт успешно удален",
        };
        this.$store.dispatch("notification/add", notification, { root: true });
        this.deletingFont = null;
      } catch (error) {
        const notification = {
          page: "error",
          message:
            error.response &&
            error.response.data &&
            error.response.data.message,
        };
        this.$store.dispatch("notification/add", notification, { root: true });
      }
    },

    async saveData() {
      try {
        await this.$store.dispatch("settings/set", {
          key: "engravingPriceSymbol",
          value: this.form.engravingPriceSymbol,
          notify: false,
        });

        await this.$store.dispatch("settings/set", {
          key: "engravingCostSymbol",
          value: this.form.engravingCostSymbol,
          notify: false,
        });

        await this.$store.dispatch("settings/set", {
          key: "engravingAllFonts",
          value: this.form.engravingAllFonts.toString(),
          notify: false,
        });

        if (this.sizes && this.sizes.length) {
          await this.$store.dispatch("settings/set", {
            key: "fontSizes",
            value: JSON.stringify(this.sizes),
            notify: false,
          });
        }

        if (
          this.form.engravingSelectedFonts &&
          this.form.engravingSelectedFonts.length
        ) {
          await this.$store.dispatch("settings/set", {
            key: "engravingSelectedFonts",
            value: JSON.stringify(this.form.engravingSelectedFonts),
            notify: false,
          });
        }
        const notification = {
          type: "success",
          message: this.$t("main.setting_save_success"),
        };
        this.$store.dispatch("notification/add", notification, { root: true });
      } catch (error) {
        const notification = {
          type: "error",
          message:
            error.response &&
            error.response.data &&
            error.response.data.message,
        };
        this.$store.dispatch("notification/add", notification, { root: true });
      }
    },
  },
  watch: {
    fonts(fonts) {
      console.log(fonts);
      if (fonts && fonts.length) {
        let newStyle = document.createElement("style");
        for (const font of fonts) {
          newStyle.appendChild(
            document.createTextNode(
              "\
      @font-face {\
          font-family: '" +
                font.name +
                "';\
          src: url('" +
                font.file +
                "');\
      }\
      "
            )
          );
        }
        document.head.appendChild(newStyle);
      }
    },
  },
};
</script>

<style scoped>
.text-sizes-list > div + div .size-data,
.font-item + .font-item {
  border-top: 1px #cfe2e8 solid;
  padding-top: 12px;
}

.font-item .font-action button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 27px;
  height: 27px;
  padding: 4px;
  border-radius: 3px;
}
.font-item .font-action button.button-edit {
  background-color: #25a24c;
}
.font-item .font-action button.button-delete {
  border: 1px #d2e4e9 solid;
}
</style>
